import React from "react";

//CSS
import "./filterIcon.css";

export default function FilterIcon({
  CategoryID,
  Type,
  CategoryName,
  Text1,
  Text2 = "",
  onClick,
}) {
  const types = ["selection", "slider"];
  const typeLocal = types.includes(Type) ? Type : types[0];
  return (
    <div className="filter-icon-container" onClick={() => onClick(CategoryID)}>
      <div className="filterIcon-text">
        {typeLocal == "slider"
          ? CategoryName + ": " + Text1 + "-" + Text2
          : CategoryName + ": " + Text1}
      </div>
      <div className="filterIcon-button">X</div>
    </div>
  );
}
